// @owners { team: patients }
import { type ColorTokens, type FontTokens, setColors, setFonts } from '@alto/design-library-tokens';
import { type Brand, LoadingEmptyState, getBrand } from '@alto/design-system';
import React, { useEffect, useState } from 'react';
import { loadImages, setImages } from '~shared/assets/images/getImage';

export async function loadBrandColors(brand: Brand): Promise<ColorTokens> {
  switch (brand) {
    case 'fuzehealth':
      // webpack: /* webpackChunkName: "colors-fuzehealth" */
      return (await import('@alto/design-library-tokens')).FUZE_HEALTH_COLORS;
    case 'alto':
    default:
      // webpack: /* webpackChunkName: "colors-alto" */
      return (await import('@alto/design-library-tokens')).ALTO_COLORS;
  }
}

export async function loadBrandFonts(brand: Brand): Promise<FontTokens> {
  switch (brand) {
    case 'fuzehealth':
      // webpack: /* webpackChunkName: "fonts-fuzehealth" */
      return (await import('@alto/design-library-tokens')).FUZE_HEALTH_FONTS;
    case 'alto':
    default:
      // webpack: /* webpackChunkName: "fonts-alto" */
      return (await import('@alto/design-library-tokens')).ALTO_FONTS;
  }
}

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const [isReady, setIsReady] = useState(false);

  // Keep the token store in sync for components importing COLORS
  useEffect(() => {
    const resolveBrand = async () => {
      const brand = getBrand();

      const [colors, fonts, images] = await Promise.all([
        loadBrandColors(brand),
        loadBrandFonts(brand),
        loadImages(brand),
      ]);

      setColors(colors);
      setFonts(fonts);
      setImages(images);
      setIsReady(true);
    };

    resolveBrand();
  }, []);

  if (!isReady) {
    return <LoadingEmptyState />;
  }

  return <div>{children}</div>;
}
